import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyTheme } from './store/themeStore';

// Apply saved theme before React renders to avoid flash
try {
  const stored = localStorage.getItem('smepro360-theme');
  if (stored) {
    const { state } = JSON.parse(stored);
    if (state?.isDark) applyTheme(true);
  }
} catch {}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: { fontSize: '14px', borderRadius: '12px', padding: '12px 16px' },
        success: { iconTheme: { primary: '#6366f1', secondary: '#fff' } },
        error: { duration: 5000 },
      }}
    />
  </React.StrictMode>
);

reportWebVitals();

// Register the service worker in production to enable PWA install + offline shell.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
